module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"ActionSidebarRedirectTitle":"Клиент будет переходить в"},"en":{"ActionSidebarRedirectTitle":"The client will go to"}}')
  delete Component.options._Ctor
}
